import Unile from '@/util'

const state = {
  count: 1,
  alredyCollect: null,
  AllQuestionObj: { // 全部试题
    continueAnswer:null, // 继续答题 0新进入 1继续
    paperId:null, // 试卷id
    question: [],
    remainTime:null// 剩余时间
  },
  remainQuestionObj:{ // 剩余试题
    continueAnswer:null, // 继续答题 0新进入 1继续
    paperId:null, // 试卷id
    question: []
  },
  AnswerList:{},
  studentName:'',
  studentPhone:'',
  showTime:false,//如果时间存在
  showTime1:false,//非必答题
  btnshow:false,//点击提交
  btnshow1:false,//点击继续测试
  remainTime:null,//在接口获取的时间
  retest:false,//判断是否重新测试
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js